export default {
	UPDATE_EVENTS_PREFIX: "store-state",
};
